import { render, staticRenderFns } from "./FormSchema.modal.vue?vue&type=template&id=cfa50ec6&scoped=true&"
import script from "./FormSchema.modal.vue?vue&type=script&lang=js&"
export * from "./FormSchema.modal.vue?vue&type=script&lang=js&"
import style0 from "./FormSchema.modal.vue?vue&type=style&index=0&id=cfa50ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa50ec6",
  null
  
)

export default component.exports